module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-MediumItalic.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-MediumItalic.ttf
// module id = 1906
// module chunks = 0